import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const RiskProLayout = lazy(() =>
  import('../components/risk-pro/RiskProLayout').then((m) => ({ default: m.RiskProLayout }))
)
const RiskProHubPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.HubPage }))
)
const RiskProCockpitPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.CockpitPage }))
)
const RiskProMatrixPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.MatrixPage }))
)
const RiskProHeatmapDrilldownPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.HeatmapDrilldownPage }))
)
const RiskProAppetitePage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.AppetitePage }))
)
const RiskProRegisterPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RegisterPage }))
)
const RiskProIdentifyWizardPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.IdentifyWizardPage }))
)
const RiskProScenariosPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.ScenariosPage }))
)
const RiskProTaxonomyPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.TaxonomyPage }))
)
const RiskProAssessmentPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.AssessmentPage }))
)
const RiskProBowtiePage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.BowtiePage }))
)
const RiskProQuantitativePage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.QuantitativePage }))
)
const RiskProControlsPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProControlsPage }))
)
const RiskProTreatmentPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.TreatmentPage }))
)
const RiskProThreeLinesPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.ThreeLinesPage }))
)
const RiskProKriPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.KriPage }))
)
const RiskProIncidentsPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProIncidentsPage }))
)
const RiskProMonitoringPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.MonitoringPage }))
)
const RiskProReportBoardPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.ReportBoardPage }))
)
const RiskProReportRiskPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.ReportRiskPage }))
)
const RiskProFrameworksPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProFrameworksPage }))
)
const RiskProIntegrationPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProIntegrationPage }))
)
const RiskProAuditTrailPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProAuditTrailPage }))
)
const RiskProTemplatesPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProTemplatesPage }))
)
const RiskProSettingsPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProSettingsPage }))
)
const RiskProOutilsPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProOutilsPage }))
)
const RiskProRiskDetailPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProRiskDetailPage }))
)
const RiskProIncidentDetailPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProIncidentDetailPage }))
)
const RiskProControlDetailPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskProControlDetailPage }))
)
const RiskProScenarioSimulatorPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.ScenarioSimulatorPage }))
)
const RiskProEarlyWarningPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.EarlyWarningPage }))
)
const RiskProControlEffectivenessPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.ControlEffectivenessPage }))
)
const RiskProRiskAppetiteDashboardPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskAppetiteDashboardPage }))
)
const RiskProRiskAppetiteMonitorPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.RiskAppetiteMonitorPage }))
)
const RiskProLossEventAnalysisPage = lazy(() =>
  import('../pages/risk-pro').then((m) => ({ default: m.LossEventAnalysisPage }))
)
const RiskProLossEventsPage = lazy(() =>
  import('../pages/risk-pro/LossEventsPage').then((m) => ({ default: m.LossEventsPage }))
)
const RiskProPredictiveRiskDashboardPage = lazy(() =>
  import('../pages/risk-pro/PredictiveRiskDashboardPage').then((m) => ({ default: m.PredictiveRiskDashboardPage }))
)
const RiskProIncidentIntelligencePage = lazy(() =>
  import('../pages/risk-pro/IncidentIntelligencePage').then((m) => ({ default: m.IncidentIntelligencePage }))
)
// Gap #24 — Monte-Carlo simulation (VaR/CVaR, OpRisk LDA capital, what-if)
const RiskProMonteCarloPage = lazy(() =>
  import('../pages/risk-pro/MonteCarloPage').then((m) => ({ default: m.MonteCarloPage }))
)
// Previously-orphaned pages (existed but unreachable → global 404)
const RiskProModelRiskPage = lazy(() =>
  import('../pages/risk-pro/ModelRiskPage').then((m) => ({ default: m.ModelRiskPage }))
)
const RiskProCapitalAdequacyPage = lazy(() =>
  import('../pages/risk-pro/CapitalAdequacyPage').then((m) => ({ default: m.CapitalAdequacyPage }))
)

// Risk Evolution Tracking pages
const RiskProHistoryPage = lazy(() => import('../pages/risk-pro/HistoryPage'))
const RiskProSnapshotsComparePage = lazy(() => import('../pages/risk-pro/SnapshotsComparePage'))
const RiskProEvolutionPage = lazy(() => import('../pages/risk-pro/EvolutionPage'))
const RiskProCorrelationsPage = lazy(() => import('../pages/risk-pro/CorrelationsPage'))
const RiskProEffectivenessPage = lazy(() => import('../pages/risk-pro/EffectivenessPage'))
const RiskProForecastPage = lazy(() => import('../pages/risk-pro/ForecastPage'))

export const riskProRoutes: RouteObject[] = [
  {
    path: '/risk-pro',
    element: <RiskProLayout />,
    children: [
      { index: true, element: <RiskProHubPage /> },

      { path: 'hub', element: <RiskProHubPage /> },
      { path: 'cockpit', element: <RiskProCockpitPage /> },
      { path: 'matrix', element: <RiskProMatrixPage /> },
      { path: 'heatmap-drilldown', element: <RiskProHeatmapDrilldownPage /> },
      // Profile-MD aliases for Risk Manager workflow
      { path: 'heatmap', element: <RiskProMatrixPage /> },
      { path: 'diagnostic', element: <RiskProCockpitPage /> },
      { path: 'framework-design', element: <RiskProAssessmentPage /> },
      { path: 'aida', element: <RiskProRegisterPage /> },
      { path: 'registry/list', element: <RiskProRegisterPage /> },
      { path: 'registry/new', element: <RiskProIdentifyWizardPage /> },
      { path: 'treatments', element: <RiskProTreatmentPage /> },
      { path: 'appetite', element: <RiskProAppetitePage /> },
      { path: 'register', element: <RiskProRegisterPage /> },
      { path: 'identify', element: <RiskProIdentifyWizardPage /> },
      { path: 'scenarios', element: <RiskProScenariosPage /> },
      { path: 'taxonomy', element: <RiskProTaxonomyPage /> },
      { path: 'assessment', element: <RiskProAssessmentPage /> },
      { path: 'bowtie', element: <RiskProBowtiePage /> },
      { path: 'quantitative', element: <RiskProQuantitativePage /> },
      { path: 'controls', element: <RiskProControlsPage /> },
      { path: 'treatment', element: <RiskProTreatmentPage /> },
      { path: 'three-lines', element: <RiskProThreeLinesPage /> },
      { path: 'kri', element: <RiskProKriPage /> },
      { path: 'incidents', element: <RiskProIncidentsPage /> },
      { path: 'monitoring', element: <RiskProMonitoringPage /> },
      { path: 'report-board', element: <RiskProReportBoardPage /> },
      { path: 'report-risk', element: <RiskProReportRiskPage /> },
      { path: 'frameworks', element: <RiskProFrameworksPage /> },
      { path: 'integration', element: <RiskProIntegrationPage /> },
      { path: 'audit-trail', element: <RiskProAuditTrailPage /> },
      { path: 'templates', element: <RiskProTemplatesPage /> },
      { path: 'settings', element: <RiskProSettingsPage /> },
      { path: 'outils', element: <RiskProOutilsPage /> },
      { path: 'risks/:id', element: <RiskProRiskDetailPage /> },
      { path: 'incidents/:id', element: <RiskProIncidentDetailPage /> },
      { path: 'controls/:id', element: <RiskProControlDetailPage /> },
      { path: 'scenario-simulator', element: <RiskProScenarioSimulatorPage /> },
      { path: 'early-warning', element: <RiskProEarlyWarningPage /> },
      { path: 'control-effectiveness', element: <RiskProControlEffectivenessPage /> },
      { path: 'risk-appetite-dashboard', element: <RiskProRiskAppetiteDashboardPage /> },
      { path: 'risk-appetite-monitor', element: <RiskProRiskAppetiteMonitorPage /> },
      { path: 'loss-event-analysis', element: <RiskProLossEventAnalysisPage /> },
      { path: 'loss-events', element: <RiskProLossEventsPage /> },
      { path: 'predictive-risk', element: <RiskProPredictiveRiskDashboardPage /> },
      { path: 'incident-intelligence', element: <RiskProIncidentIntelligencePage /> },
      // Gap #24 — Monte-Carlo (matches nav-registry href /risk-pro/montecarlo)
      { path: 'montecarlo', element: <RiskProMonteCarloPage /> },
      // Previously-orphaned pages now reachable
      { path: 'model-risk', element: <RiskProModelRiskPage /> },
      { path: 'capital-adequacy', element: <RiskProCapitalAdequacyPage /> },

      // Risk Evolution Tracking
      { path: 'risks/:id/history', element: <RiskProHistoryPage /> },
      { path: 'risks/:id/snapshots', element: <RiskProSnapshotsComparePage /> },
      { path: 'risks/:id/forecast', element: <RiskProForecastPage /> },
      { path: 'portfolio/evolution', element: <RiskProEvolutionPage /> },
      { path: 'correlations', element: <RiskProCorrelationsPage /> },
      { path: 'effectiveness', element: <RiskProEffectivenessPage /> },
    ],
  },
]
